/**
 * FeedbackWidget — bindet das feedbackhub-Widget in den angemeldeten Bereich ein.
 *
 * feedbackhub (https://feedback.vm.8thsense.de) ist die eigene Feedback-/Ticket-
 * Plattform: ein Script-Tag genügt, das Widget baut sich selbst per Shadow-DOM
 * auf (keine Style-Konflikte mit dem CRM) und meldet Bug/Änderung/Feature
 * gegen das Projekt „Senihelp24 CRM 2.0" im Hub.
 *
 * Bewusst NICHT in index.html: dort läge der Button auch auf der Login-Seite.
 * Diese Komponente rendert nur im authentifizierten Shell-Baum (App.tsx).
 *
 * Abschalten ohne Codeänderung: Build mit `VITE_FEEDBACK_PROJECT_KEY=` (leer)
 * — dann wird kein Script geladen. Der Projekt-Key ist öffentlich (er steht im
 * Script-Tag jeder einbettenden Seite, der Hub akzeptiert ihn per CORS), daher
 * ist der Default hier hartkodiert und nicht als Deploy-Geheimnis zu behandeln.
 *
 * ACHTUNG Datenschutz: Das Widget erstellt beim Öffnen automatisch einen
 * Screenshot der aktuellen Seite und schickt ihn mit dem Ticket an den Hub.
 * Im CRM sind darauf Klardaten von Pflegebedürftigen zu sehen. Vor einer
 * Nutzung über Staging hinaus klären (Hub läuft auf 8thsense-Infrastruktur,
 * nicht in der Senihelp24-Umgebung).
 */
import { useEffect } from 'react';

const HUB_ORIGIN = 'https://feedback.vm.8thsense.de';

/** Projekt „Senihelp24 CRM 2.0" im Hub; öffentlicher Key, kein Geheimnis. */
const DEFAULT_PROJECT_KEY = 'fb_WDweT3Tdqwh9E0A4g5GLB5Se';

const PROJECT_KEY = import.meta.env.VITE_FEEDBACK_PROJECT_KEY ?? DEFAULT_PROJECT_KEY;

const SCRIPT_ID = 'fbhub-widget';

export function FeedbackWidget() {
  useEffect(() => {
    if (!PROJECT_KEY) return;
    // Doppel-Mount (StrictMode) und Reloads im gleichen Dokument abfangen:
    // das Widget selbst schützt sich per window.__fbhubLoaded, das Script-Tag
    // würde sonst trotzdem mehrfach im DOM landen.
    if (document.getElementById(SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `${HUB_ORIGIN}/widget.js`;
    script.async = true;
    script.dataset.project = PROJECT_KEY;
    // compact = runder 44px-Button, Label fährt erst bei Hover aus — im CRM
    // steht der Button sonst dauerhaft über den Inhalten.
    script.dataset.launcher = 'compact';
    document.body.appendChild(script);

    return () => {
      script.remove();
      document.getElementById('fbhub-root')?.remove();
      // Ohne Reset bliebe das Widget nach Abmelden/Anmelden im selben
      // Dokument stumm (Selbstschutz-Flag im Widget).
      (window as unknown as { __fbhubLoaded?: boolean }).__fbhubLoaded = false;
    };
  }, []);

  return null;
}
